module.exports = __webpack_public_path__ + "img/tablo_hover_c7d2fcb.webp";